import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ko from "./locales/ko.json";
import fr from "./locales/fr.json";
import zh from "./locales/zh.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import hi from "./locales/hi.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import ja from "./locales/ja.json";
import it from "./locales/it.json";
import de from "./locales/de.json";
import vi from "./locales/vi.json";
import tl from "./locales/tl.json";
import id from "./locales/id.json";
import exerciseNames from "./exerciseNames";

// Merge exercise translations into each locale
const locales: Record<string, any> = { en, ko, fr, zh, es, ar, hi, pt, ru, ja, it, de, vi, tl, id };
const resources: Record<string, { translation: any }> = {};

for (const [lang, locale] of Object.entries(locales)) {
  resources[lang] = {
    translation: {
      ...locale,
      exercises: {
        ...(locale as any).exercises,
        ...(exerciseNames[lang] || {}),
      },
    },
  };
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
